import {ModalBody, ModalFooter, ModalHeader} from "@heroui/modal";
import {Button, ButtonGroup} from "@heroui/button";
import React, {useEffect} from "react";

import {getPreferredExt} from "@/components/DownloaderApp/utils";

import {useMonitoring} from "@/components/monitoring";
import {DownloadIcon} from "@/components/DownloaderApp/icons";

export function RumbleChooseQualityPopup({data, onAccept}) {
    const hasVideo = !!data.video?.downloadLink;
    const hasAudio = !!data.video?.audioUrl;

    const options = [
        ...(hasVideo ? [{key: '.mp4', label: '.mp4', speed: 'fast'}, {key: '.mp3', label: 'audio (.mp3)', speed: 'slower'}] : []),
        ...(hasAudio ? [{key: '.aac', label: 'audio (.aac)', speed: 'fastest'}] : []),
    ];

    const preferred = getPreferredExt() === '.mp3' ? '.mp3' : '.mp4';
    const defaultExt = options.find(o => o.key === preferred)?.key ?? options[0]?.key;

    const [ext, setExt] = React.useState<'.mp4' | '.mp3' | '.aac'>(defaultExt);

    const {track, onClickTrack} = useMonitoring()

    function onDownloadClicked() {
        track(`Rumble download`, {ext, speed: options.find(o => o.key === ext)?.speed})
        onAccept({ext})
    }

    useEffect(() => {
        if (ext === '.mp3' || ext === '.aac') return;
        // localStorage.ext = ext
    }, [ext]);

    return (
        <>
            <ModalHeader className="flex flex-col gap-1">
        <span id="modal-title">
          Customize download
        </span>
            </ModalHeader>
            <ModalBody className={"py-4 px-3 md:px-5"}>
                <div className={"flex flex-col gap-6"}>
                    <h2 className={"text-xl "}>Content format</h2>
                    <ButtonGroup size={"lg"} className={"flex"}>
                        {options.map((option, index) => (
                            <Button
                                onPress={(e) => onClickTrack(`Format change`, {extension: option.key})(e) || setExt(option.key)}
                                key={index}
                                color={option.key === ext ? "primary" : "default"}
                                variant={"solid"}>
                                <div className={"flex flex-col"}>
                                    <span>{option.label}</span>
                                    <span className={"text-xs opacity-70"}>{option.speed}</span>
                                </div>
                            </Button>
                        ))}
                    </ButtonGroup>
                </div>

                <Button color="primary" className={"mt-5"} onPress={onDownloadClicked} startContent={<DownloadIcon/>}>
                    <span><span className={"capitalize"}>{options.find(o => o.key === ext)?.speed || ""}</span> Download ({ext})</span>
                </Button>
            </ModalBody>
            <ModalFooter>
            </ModalFooter>
        </>
    );
}
